import React, { useState, useEffect } from 'react';
import Header from '../Header/Header'
import Disponibilidad from '../../Components/Coordinador/Disponibilidad'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import { useLocation } from 'react-router-dom';
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';
import { puedeVerMenu } from '../../Helpers/rolesPermisos';

export default function CitasCoordinador() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario(); // Llama a la función para obtener datos del usuario
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container2'>

                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {puedeVerMenu(usuarioLegued.rol, 'disponibilidad') ? (
                                <Disponibilidad />
                            ) : (
                                <SinPermisos />
                            )}
                        </>
                    ) : (
                        <SinPermisos />
                    )}

                </div>
            </section>
        </div>
    )
}

